import {Component} from 'react'
import {Redirect} from 'react-router-dom'
import Cookies from 'js-cookie'
import ReactPlayer from 'react-player'

import {BiLike, BiDislike} from 'react-icons/bi'
import {MdPlaylistAdd} from 'react-icons/md'

import AppContext from '../../context/AppContext'
import LoaderEl from '../Loader'
import FailureView from '../FailureView'
import Header from '../Header'
import SideBar from '../SideBar'

import {
  VideoItemDetailsContainer,
  VideoContainer,
  VideoItemDetailsDescriptionContainer,
  VideoItemDetailsTitle,
  VideoItemDetailsElContainer,
  FirstContainer,
  ViewsPara,
  DurationPara,
  SecondContainer,
  ReviewConatainer,
  VideoItemDetailsLikeIcon,
  VideoItemDetailsDisLikeIcon,
  VideoItemDetailsSaveIcon,
  ReviewLikePara,
  ReviewDisLikePara,
  ReviewSavePara,
  HorizontalLine,
  VideoItemDetailsLogoContainer,
  VideoItemDetailsLogo,
  VideoItemDetailsChannelDetails,
  VideoItemDetailsChannelName,
  VideoItemDetailsChannelSubscribers,
  VideoItemDetailsChannelDescription,
} from './styledComponents'

const apiStatusConstants = {
  initial: 'INITIAL',
  inProgress: 'IN PROGRESS',
  success: 'SUCCESS',
  failure: 'FAILURE',
}

class VideoItemDetails extends Component {
  state = {
    apiStatus: apiStatusConstants.initial,
    videoDetails: [],
  }

  componentDidMount() {
    this.videoApiCall()
  }

  videoItemDetailsRetryBtn = () => {
    this.videoApiCall()
  }

  videoApiCall = async () => {
    this.setState({apiStatus: apiStatusConstants.inProgress})
    const {match} = this.props
    const {params} = match
    const {id} = params
    const jwtToken = Cookies.get('jwt_token')
    const url = `https://apis.ccbp.in/videos/${id}`
    const options = {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      method: 'GET',
    }
    const response = await fetch(url, options)
    if (response.ok === true) {
      const data = await response.json()
      const formattedData = {
        id: data.video_details.id,
        title: data.video_details.title,
        videoUrl: data.video_details.video_url,
        thumbnailUrl: data.video_details.thumbnail_url,
        channelName: data.video_details.channel.name,
        channelProfileImageUrl: data.video_details.channel.profile_image_url,
        channelSubscriberCount: data.video_details.channel.subscriber_count,
        channel: data.video_details.channel,
        viewCount: data.video_details.view_count,
        publishedAt: data.video_details.published_at,
        description: data.video_details.description,
      }

      this.setState({
        apiStatus: apiStatusConstants.success,
        videoDetails: formattedData,
      })
    } else {
      this.setState({apiStatus: apiStatusConstants.failure})
    }
  }

  renderSuccessView = () => {
    const {videoDetails} = this.state
    return (
      <AppContext.Consumer>
        {value => {
          const {
            theme,
            duration,
            isliked,
            isDisliked,
            onClickLikeBtn,
            onClickDislikeBth,
            onClickSaveBtn,
            savedVideoList,
          } = value

          const {match} = this.props
          const {params} = match
          const {id} = params

          const isVideoSaved = savedVideoList.some(each => each.id === id)
          console.log(savedVideoList, isVideoSaved)

          const onClickLike = () => {
            onClickLikeBtn()
          }

          const onClickDislike = () => {
            onClickDislikeBth()
          }

          const onClickSave = () => {
            onClickSaveBtn(videoDetails)
          }

          return (
            <VideoItemDetailsContainer
              data-testid="videoItemDetails"
              theme={theme}
            >
              <VideoContainer>
                <ReactPlayer
                  controls
                  url={videoDetails.videoUrl}
                  width="100%"
                  height="100%"
                />
              </VideoContainer>
              <VideoItemDetailsDescriptionContainer theme={theme}>
                <VideoItemDetailsTitle theme={theme}>
                  {videoDetails.title}
                </VideoItemDetailsTitle>
                <VideoItemDetailsElContainer theme={theme}>
                  <FirstContainer theme={theme}>
                    <ViewsPara as="p" theme={theme}>
                      {videoDetails.viewCount} views
                    </ViewsPara>
                    <DurationPara as="p" theme={theme}>
                      {videoDetails.publishedAt}{' '}
                      {duration(videoDetails.publishedAt)}
                    </DurationPara>
                  </FirstContainer>
                  <SecondContainer theme={theme}>
                    <ReviewConatainer
                      type="button"
                      onClick={onClickLike}
                      theme={theme}
                    >
                      <VideoItemDetailsLikeIcon
                        as={BiLike}
                        isliked={isliked}
                        theme={theme}
                      />
                      <ReviewLikePara isliked={isliked} theme={theme}>
                        Like
                      </ReviewLikePara>
                    </ReviewConatainer>
                    <ReviewConatainer
                      type="button"
                      onClick={onClickDislike}
                      theme={theme}
                    >
                      <VideoItemDetailsDisLikeIcon
                        as={BiDislike}
                        theme={theme}
                        isDisliked={isDisliked}
                      />
                      <ReviewDisLikePara theme={theme} isDisliked={isDisliked}>
                        Dislike
                      </ReviewDisLikePara>
                    </ReviewConatainer>
                    <ReviewConatainer
                      type="button"
                      onClick={onClickSave}
                      theme={theme}
                    >
                      <VideoItemDetailsSaveIcon
                        as={MdPlaylistAdd}
                        theme={theme}
                        isSaved={isVideoSaved}
                      />
                      <ReviewSavePara theme={theme} isSaved={isVideoSaved}>
                        {isVideoSaved ? 'Saved' : 'Save'}
                      </ReviewSavePara>
                    </ReviewConatainer>
                  </SecondContainer>
                </VideoItemDetailsElContainer>
                <HorizontalLine theme={theme} />
                <VideoItemDetailsLogoContainer theme={theme}>
                  <VideoItemDetailsLogo
                    theme={theme}
                    src={videoDetails.channelProfileImageUrl}
                    alt="channel logo"
                  />
                  <VideoItemDetailsChannelDetails theme={theme}>
                    <VideoItemDetailsChannelName theme={theme}>
                      {videoDetails.channelName}
                    </VideoItemDetailsChannelName>
                    <VideoItemDetailsChannelSubscribers theme={theme}>
                      {videoDetails.channelSubscriberCount} views
                    </VideoItemDetailsChannelSubscribers>
                    <VideoItemDetailsChannelDescription theme={theme}>
                      {videoDetails.description}
                    </VideoItemDetailsChannelDescription>
                  </VideoItemDetailsChannelDetails>
                </VideoItemDetailsLogoContainer>
              </VideoItemDetailsDescriptionContainer>
            </VideoItemDetailsContainer>
          )
        }}
      </AppContext.Consumer>
    )
  }

  render() {
    const {apiStatus} = this.state
    const jwtToken = Cookies.get('jwt_token')
    const {match} = this.props
    const {path} = match
    if (jwtToken === undefined) {
      return <Redirect to="/login" />
    }
    return (
      <div data-testid="videoItemDetails">
        <Header />
        <SideBar path={path} />
        {(() => {
          switch (apiStatus) {
            case apiStatusConstants.inProgress:
              return <LoaderEl />
            case apiStatusConstants.failure:
              return (
                <FailureView
                  videoItemDetailsRetryBtn={this.videoItemDetailsRetryBtn}
                  path={path}
                />
              )
            case apiStatusConstants.success:
              return this.renderSuccessView()
            default:
              return null
          }
        })()}
      </div>
    )
  }
}

export default VideoItemDetails
